import React from "react";
import "./Copyright.css";

const Copyright = () => {
  return (
    <div className="copyright-container">
      <div className="copyright-content">
        <p className="copyright-text">
          © {new Date().getFullYear()} JACK AND JILL MATRICULATION SCHOOL. All Rights Reserved.
        </p>
      </div>

      <div className="company-credit-container">
        <p className="company-credit">
          Designed & Developed by{" "}
          <a
            href="https://www.sdlcreativegroups.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="company-link"
          >
            SYED DREAMLOOM CREATIVE GROUPS
          </a>
        </p>
        <p className="company-tagline">
          Software Company | Web Solutions & Digital Services
        </p>
      </div>
    </div>
  );
};

export default Copyright;
